<div class="modal-header">
    <div class="title">
        <h2 class="modal-title-prefix">Kreiranje nove firme</h2>
        <h1 class="modal-title">
            Nova firma
        </h1>
    </div>
    <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <company-register-update #baseUpdate></company-register-update>
</div>
<div class="modal-footer">
    <button
        type="submit"
        class="btn btn-primary"
        (click)="Save()"
        [ngClass]="{'loader': registeringCompany}"
        [disabled]="registeringCompany"
    >
        Sačuvaj
    </button>
    <button type="button" class="btn btn-secondary" (click)="Close()">Zatvori</button>
</div>